import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "childCalendarContent posRe" }
const _hoisted_2 = {
  class: "fl ofh",
  style: `height:60px;width:100px;`
}
const _hoisted_3 = { class: "fr" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = {
  key: 0,
  class: "fs11 fw600 dgrey"
}
const _hoisted_6 = {
  class: "posRe fl ofh",
  style: {"width":"calc(100% - 100px)","height":"40px"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "w100 rad4 posAb lyellowgreyBg",
  style: {"height":"40px"}
}, null, -1)
const _hoisted_8 = {
  key: 0,
  class: ""
}
const _hoisted_9 = { style: {"margin-left":"4px"} }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "fs11" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "fs12" }, "予定あり", -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_17 = ["src"]
const _hoisted_18 = ["href"]
const _hoisted_19 = ["src"]
const _hoisted_20 = ["src"]
const _hoisted_21 = ["href"]
const _hoisted_22 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.events.filter(ev => ev.allday), (event, alldayindex) => {
          return (_openBlock(), _createElementBlock("div", { key: alldayindex }, [
            _withDirectives(_createElementVNode("div", {
              class: _normalizeClass(`${event.ignore_allday ? `orangePinkBg` : `blackbrownBg`} rad6 fr`),
              style: {"width":"12px","height":"12px","margin-right":"10px"}
            }, null, 2), [
              [_directive_tooltip, 
                            `${event.title ? `${event.title}` : `終日予定あり`}${event.location ? `@${event.location}` : ``}`
                        ]
            ])
          ]))
        }), 128))
      ]),
      _hoisted_4,
      (_ctx.calendarName)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.calendarName), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      (_ctx.possible_events)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.possible_events, (avzone, poseventIndex) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `${avzone.type}${avzone.start_time}${poseventIndex}`
              }, [
                _createElementVNode("div", {
                  class: "posAb orangePinkBg availableEvent rad5 ofh",
                  style: _normalizeStyle(`opacity:0.8;height:40px; width: ${(avzone.duration / 60) * 60}px;left: ${
                            (avzone.start_hour - 8 + avzone.start_min / 60) * 60
                        }px;`)
                }, null, 4)
              ]))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.events, (event, evindex) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `${event.type}${event.start_time}${evindex}`
              }, [
                (!event.allday)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "posAb blackbrownBg pad2 availableEvent rad5 ofh",
                      style: _normalizeStyle(`height:40px; width: ${(event.duration / 60) * 60}px;left: ${
                            (event.start_hour - 8 + event.start_min / 60) * 60
                        }px;`)
                    }, [
                      _createElementVNode("span", _hoisted_9, [
                        (_ctx.dailyEventsInfo.event_readable)
                          ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, [
                              _createElementVNode("span", _hoisted_11, _toDisplayString(event.title), 1),
                              _hoisted_12
                            ])), [
                              [_directive_tooltip, `${event.title}${event.location ? `@${event.location}` : ``}`]
                            ])
                          : (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
                      ])
                    ], 4))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_16,
    (_ctx.travelTimeBefore > 0 && _ctx.travelTimeBeforeStart)
      ? _withDirectives((_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "posAb bufferYellowBg rad3",
          style: _normalizeStyle(`opacity:0.7;width:${_ctx.travelTimeBefore}px;left:${
                100 + (_ctx.travelTimeBeforeStart.hour - 8 + _ctx.travelTimeBeforeStart.minute / 60) * 60
            }px;height:40px;top:0px;`)
        }, [
          (_ctx.travelTimeDic.before.mode == `fixed`)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.$getAssetImageUrl(`/assets/icons/both_arrows.png`),
                height: "16",
                width: "24",
                style: _normalizeStyle(`margin-top:12px;margin-left:${(_ctx.travelTimeBefore - 24) / 2}px`)
              }, null, 12, _hoisted_17))
            : (_openBlock(), _createElementBlock("a", {
                key: 1,
                href: _ctx.locationHref(`before`),
                target: "_blank",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clickGoogleRoute(`before`)))
              }, [
                _createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(`/assets/icons/fromto.png`),
                  width: "28",
                  height: "28",
                  class: "posRe pointer",
                  style: _normalizeStyle(`margin-top:6px;margin-left:${(_ctx.travelTimeBefore - 28) / 2}px`)
                }, null, 12, _hoisted_19)
              ], 8, _hoisted_18))
        ], 4)), [
          [
            _directive_tooltip,
            `${_ctx.tooltipBefore ? `${_ctx.tooltipBefore}` : ``}`,
            void 0,
            { top: true }
          ]
        ])
      : _createCommentVNode("", true),
    (_ctx.travelTimeAfter > 0 && _ctx.travelTimeAfterStart)
      ? _withDirectives((_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "posAb bufferYellowBg rad3",
          style: _normalizeStyle(`opacity:0.7;width:${_ctx.travelTimeAfter}px;left:${
                100 + (_ctx.travelTimeAfterStart.hour - 8 + _ctx.travelTimeAfterStart.minute / 60) * 60
            }px;height:40px;top:0px;`)
        }, [
          (_ctx.travelTimeDic.after.mode == `fixed`)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.$getAssetImageUrl(`/assets/icons/both_arrows.png`),
                height: "16",
                width: "24",
                style: _normalizeStyle(`margin-top:12px;margin-left:${(_ctx.travelTimeAfter - 24) / 2}px`)
              }, null, 12, _hoisted_20))
            : (_openBlock(), _createElementBlock("a", {
                key: 1,
                href: _ctx.locationHref(`after`),
                target: "_blank",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clickGoogleRoute(`after`)))
              }, [
                _createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(`/assets/icons/fromto.png`),
                  width: "28",
                  height: "28",
                  class: "posRe",
                  style: _normalizeStyle(`margin-top:6px;margin-left:${(_ctx.travelTimeAfter - 28) / 2}px`)
                }, null, 12, _hoisted_22)
              ], 8, _hoisted_21))
        ], 4)), [
          [
            _directive_tooltip,
            `${_ctx.tooltipAfter ? `${_ctx.tooltipAfter}` : ``}`,
            void 0,
            { top: true }
          ]
        ])
      : _createCommentVNode("", true)
  ]))
}